import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "@material-ui/core";
import OverflowTooltip from "../../../components/OverflowTooltip/OverflowTooltip";
import FontIcon from "../../../components/FontIcon";
import { urlNormalizer } from "../../../helpers";
import { getFileSize } from "../../academic/modals/helpers/helperFunctions";
import { IAttachFileItemProps } from "../types";

const useStyles = makeStyles(() => ({
  root: {
    height: 44,
    width: 183,
    borderRadius: 22,
    backgroundColor: "#EEEFF3",
    display: "flex",
    columnGap: 8,
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 8px 5px 11px",
  },
  fileIcon: {
    color: "#858997",
    fontSize: 18,
  },
  fileName: {
    fontSize: 14,
    color: "#192130",
    width: 112,
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underLine",
    },
  },
  fileSize: {
    fontSize: 12,
    color: "#858997",
  },
  deleteIcon: {
    color: "#C2C9D6",
    fontSize: 18,
    borderRadius: "50%",
    transition: "box-shadow 0.2s ease-out",
    "&:hover": {
      boxShadow: "0px 0px 4px #bbbcbf",
      borderRadius: "50%",
      cursor: "pointer",
    },
  },
}));

export const AttachFileItem: FC<IAttachFileItemProps> = ({
  id,
  name,
  size,
  preview,
  removeFile,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root} onClick={(e) => e.stopPropagation()}>
      <FontIcon name="file" className={classes.fileIcon} />
      <div>
        <div className={classes.fileName}>
          <Link href={urlNormalizer(preview)} target="_blank" underline="none">
            <OverflowTooltip text={name} />
          </Link>
        </div>
        <div className={classes.fileSize}>{getFileSize(size)}</div>
      </div>
      <FontIcon
        name="close"
        className={classes.deleteIcon}
        onClick={() => removeFile(id)}
      />
    </div>
  );
};
